import { INews } from "@src/interface/News";
import { RollingStartEndpointBuilder } from "../apiTypes";

export const createNewsEndpoints = (builder: RollingStartEndpointBuilder) => ({
  getNewsItem: builder.query<INews, { id: string }>({
    query: ({ id }) => ({
      url: `/news/${id}`,
      method: "GET",
    }),
  }),
  getNews: builder.query<INews[], void>({
    query: () => ({
      url: `/news`,
      method: "GET",
    }),
  }),
});
